module.exports = __webpack_public_path__ + "static/media/oneclicrh.cfb545df.jpg";